import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Leads } from '../leads.model';
import { LeadsService } from '../leads.service';
import { HelperService } from '../helper.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {
  //declare variables
  lead: Leads = new Leads();
  bRobot: boolean = false;

  //inject services
  constructor(private ls: LeadsService, private router: Router, private hs: HelperService) { }

  ngOnInit(): void {
  }

  //save a new contact
  save() {
    if (this.lead.email == '') {
      window.alert("You must provide a valid corporate email address to Register with RegScale.");
    } else if (this.hs.checkEmail(this.lead.email) == false) {
      this.lead.email = '';
      window.alert("You must provide a corporate email to register with RegScale.  Personal emails are not permitted.");
    } else {
      //update some of the data
      this.lead.dateSubmitted = new Date();
      this.lead.page = this.router.url;
      this.lead.id = this.hs.createGUID();

      //save the record
      this.ls.save(this.lead);

      //clear the form
      this.lead = new Leads();
      this.bRobot = false;

      //navigate to the thank you page
      this.router.navigate(['/thank-you/contact']);
    }
  }

  //check for personal email
  checkEmail() {
    if (this.hs.checkEmail(this.lead.email) == false) {
      this.lead.email = '';
      window.alert("You must provide a corporate email to register with RegScale.  Personal emails are not permitted.");
    }
  }

}
